import API from '../../../../../services/api';

export const DEVOLUCIONES_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/devoluciones?page=${page}${search || ''}`).then(res => res.data);
    },
    new: async (devolucion) => {
        return API.post('/devoluciones', devolucion).then(res => res.data);
    },
    update: async (devolucion) => {
        return API.put('/devoluciones/' + devolucion.id, devolucion).then(res => res.data);
    }
}